import { DocumentType, gql } from "@/generated/gql";

export const BaseOrganizationFragment = gql(/* GraphQL */ `
  fragment BaseOrganization on Organization {
    id
    key
    url
    emailFrom

    settings {
      requireTeamBeforeSelectingProtocol
      responsesExpireAfter
      treatProfessionalAsRegularRespondent
    }

    teams(limit: 100000) {
      id
      name
      emailFrom
    }
  }
`);

export type BaseOrganization = DocumentType<typeof BaseOrganizationFragment>;

export const BaseDossierFragment = gql(/* GraphQL */ `
  fragment BaseDossier on Dossier {
    id
    epdId
    respondentSource
    syncStatusMessage

    patientRespondent {
      id
      firstname
      lastname
      formalName
      administrativeGender
      birthdate
      deceased
    }

    respondents {
      id
      type
      label
      firstname
      lastname
      administrativeGender
      pronounPreset
      pronounOverrides {
        subject
        object
        possessiveDeterminer
        honorific
        honorificWithArticle
      }
      birthdate
      email
      phoneCell
      isEditable
      isEmailEditable
      loginToken
    }
  }
`);

export type BaseDossier = DocumentType<typeof BaseDossierFragment>;
export type BaseRespondent = BaseDossier["respondents"][number];

export const CurrentUserFragment = gql(/* GraphQL */ `
  fragment CurrentUser on Professional {
    __typename
    id
    epdId
    firstname
    lastname
    username
    email
    team {
      id
      name
    }
    preferences {
      expandedEpdNavbar
      locale
    }
    rights {
      testingTools
      inviteRespondentsToCreateAccounts
    }
    announcementsLastSeenAt
    hiddenTutorials
  }
`);

export type CurrentUser = DocumentType<typeof CurrentUserFragment>;

export const CurrentSessionFragment = gql(/* GraphQL */ `
  fragment CurrentSession on ApiSession {
    id
    loggedIn
    locale
    type
    environment
    organizationId
    dossierId

    user {
      ... on Professional {
        ...CurrentUser
      }
    }

    navbarGroups {
      key
      header
      items {
        key
        label
        icon
        tooltip
        href
      }
    }
  }
`);

export type CurrentSession = DocumentType<typeof CurrentSessionFragment>;

export const BaseDataQuery = gql(/* GraphQL */ `
  query BaseData($organizationKey: String!, $dossierId: ID!) {
    session {
      ...CurrentSession
    }

    organization(key: $organizationKey) {
      ...BaseOrganization
    }

    dossier(id: $dossierId) {
      ...BaseDossier
    }
  }
`);
